import * as React from 'react'
import { FC } from 'react'
import { useParams } from 'react-router-dom'
import { useGetShipmentByDocIdQuery } from '../../store/api/shipments-api'
import styled from 'styled-components'

const Header = styled.header`
    height: 100px;
`

interface BlankPageProps {
    // shipment: Shipment
}

const BlankPage: FC<BlankPageProps> = () => {
    const { shipmentDocId } = useParams()
    const getShipmentState = useGetShipmentByDocIdQuery([shipmentDocId || '', { populate: '*' }], {
        skip: !shipmentDocId,
    })
    const shipment = getShipmentState.data?.data

    if (!shipmentDocId) return <>Отгрузка не найдена</>

    return (
        <Header>
            <div>
                Заказчик: <b>{shipment?.client?.name}</b>
            </div>
            <div>
                Номер заказа: <b>{shipment?.id}</b>
            </div>
            <div>
                Тираж:{' '}
                <b>
                    {shipment?.shipment_positions?.reduce(
                        (sum, item) => sum + (Number(item.copies) || 0),
                        0
                    )}
                </b>
            </div>
        </Header>
    )
}

export default BlankPage
